import React from 'react'

import Button from '@components/Button'
import Favorite from '@components/Favorite'
import SafeHTML from '@components/SafeHTML'
import Tag from '@controllers/common/Tag'
import { trans, BACK, PUBLISH_DATE } from '@helpers/translator'
import useFavorite from '@hooks/useFavorite'

interface HeaderProps {
  id: number
  description?: string
  date?: string
  tags?: string[]
  displayFavorite?: boolean
}

export const Header: React.FC<HeaderProps> = ({
  id,
  description,
  date,
  tags,
  displayFavorite = false,
}) => {
  const { isFavorite, toggleFavorite } = useFavorite(id)

  return (
    <div>
      {((displayFavorite && id) || date) && (
        <div className="flex items-center justify-between">
          {date && (
            <p className="text-grey-dark text-base leading-[21px] font-medium mt-4">
              {trans(PUBLISH_DATE)} : {date}
            </p>
          )}
          {displayFavorite && id && (
            <Favorite
              className="text-[16px] leading-5 font-medium ml-auto mt-4 print:hidden"
              isFavorite={isFavorite}
              onClick={toggleFavorite}
              inverted={true}
              displayLabel={true}
              iconSize="16"
            />
          )}
        </div>
      )}
      {description && (
        <SafeHTML
          className="prose text-[21px] leading-[32px] mt-4"
          html={description}
        />
      )}
      {tags && (
        <div className="flex flex-wrap gap-x-3 mt-7.5 xl:mt-5">
          {tags.map((tag) => (
            <Tag key={tag} tag={tag} />
          ))}
        </div>
      )}
    </div>
  )
}

export default Header
